export const VERTICAL_TAB_ONE = 'v-tab-1';
export const VERTICAL_TAB_TWO = 'v-tab-2';
export const VERTICAL_TAB_THREE = 'v-tab-3';
export const PAYMENT_SCORE = 'payment-score';
export const CUG_SCORE = 'cug-score';
export const RISK_SCORE = 'risk-score';
export const PAYEMNT_VALUES_DEFAULT = [{
    id: '',
    name: '',
    headerName: '',
    value: '',
    type: '',
    seqNum: ''
}];
export const DEFUALT_CONVERION_LIMIT = 1000;
export const VERTICAL_AGGREGATION_DATA = 'Vertical Aggregated Data'
export const VERTICAL_AGGREGATION_COLUMNS = ['Jan 2018', 'Feb 2018', 'Mar 2018', 'Apr 2018', 'May 2018', 'Jun 2018', 'Jul 2018', 'Aug 2018', 'Sep 2018', 'Oct 2018', 'Nov 2018', 'Dec 2018']